import script from "./Logout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logout.vue?vue&type=script&setup=true&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=5ab6104f&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab6104f"]])

export default __exports__